/**
 * Today strip model — overdue first, then due today.
 * Chef call list must not wait on Needs you.
 */

import {
  formatHarbourOverdueBanner,
  isHarbourNamelessVenueName,
} from 'src/constants/harbour'

function followUpTime(card) {
  if (!card?.nextFollowUpAt) {
    return Number.POSITIVE_INFINITY
  }
  const time = new Date(card.nextFollowUpAt).getTime()
  return Number.isFinite(time) ? time : Number.POSITIVE_INFINITY
}

function todayRank(card) {
  if (card?.overdue) {
    return 0
  }
  if (card?.nextFollowUpLabel === 'Today') {
    return 1
  }
  if (card?.forgotten) {
    return 2
  }
  return 3
}

/**
 * @param {object[]} cards
 * @returns {object[]}
 */
export function sortHarbourTodayCards(cards = []) {
  return (Array.isArray(cards) ? cards : [])
    .filter(card => card?.venueId)
    .map((card, index) => ({ card, index }))
    .sort((left, right) => {
      const rank = todayRank(left.card) - todayRank(right.card)
      if (rank) {
        return rank
      }
      const nameless =
        Number(isHarbourNamelessVenueName(left.card.venueName)) -
        Number(isHarbourNamelessVenueName(right.card.venueName))
      if (nameless) {
        return nameless
      }
      const due = followUpTime(left.card) - followUpTime(right.card)
      if (due) {
        return due
      }
      return left.index - right.index
    })
    .map(entry => entry.card)
}

export function countHarbourOverdueCards(cards = []) {
  return (Array.isArray(cards) ? cards : []).filter(card => card?.overdue)
    .length
}

export function getHarbourTodayNudge(cards = []) {
  return formatHarbourOverdueBanner(countHarbourOverdueCards(cards))
}
